import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DataService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super();
  }

  getSecureData(): Observable<string> {
    
    return this.http
      .get(this.getApiURI() + '/Data/GetData')
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/data.service.ts